export const INFO_MODAL_AUTOHIDE_MS = 3000;

export const PREFETCH_VARIANTS = {
    GRAPH: "graph",
    ATTRIBUTE: "attribute"
};

export const OUTPUT_TYPES = {
    CHUNK: "CHUNK",
    REASONING: "CHUNK",
    FINAL: "COMPLETE",
    PROCESSED: "PROCESSED",
    ERROR: "ERROR",
    TOOL_START: "TOOL_START",
    TOOL_END: "TOOL_END",
    GRAPH_TOOL_END: "GRAPH_TOOL_END",
    TABLE_TOOL_END: "TABLE_TOOL_END",
    CHART_TOOL_END: "CHART_TOOL_END"
};

export const GRAPH_RESPONSE_MESSAGES = {
    BASIC_ERROR: "There was an error processing the graph data through basic graph analysis for your query. Our advanced analysis is still running and may provide additional insights shortly.",
    ADVANCED_ERROR: "There was an error processing the graph data through advanced graph analysis for your query. Please try again or contact support if the issue persists.",
    BASIC_GRAPH_NO_RESPONSE: "No immediate results found. Our advanced analysis is still running and may provide additional insights shortly.",
    ADVANCED_GRAPH_NO_RESPONSE: "No additional data found through advanced analysis. Try refining your search with more specific keywords or different terms.",
    BASIC_GRAPH_SUCCESS: "Initial graph data loaded successfully. Switch to advanced mode for deeper insights.",
    ADVANCED_GRAPH_SUCCESS: "Advanced analysis complete! New connections and deeper insights have been added to your graph.",
    BASIC_GRAPH_ONLY_TYPE: (nodeType) => `Initial graph contains only ${nodeType} nodes. Switch to advanced mode for deeper insights.`,
    ADVANCED_GRAPH_ONLY_TYPE: (nodeType) => `Advanced analysis found only ${nodeType} nodes. Try refining your search for more diverse results.`
};

export const GRAPH_MODES = {
    BASIC: "BASIC",
    ADVANCED: "ADVANCED"
};

export const VIEW_TYPES = {
    GRAPH: "GRAPH",
    TABLE: "TABLE"
    // CHART: "CHART"
};

export const EMPTY_GRAPH_DATA = {
    nodes: [],
    edges: []
};

export const INITIAL_GRAPH_STATE = {
    data: null,
    updatedData: null,
    tableData: [],
    chartData: [],
    loading: false,
    error: false,
    lastQuery: '',
    latestHasData: false
};
